export default __webpack_public_path__ + "static/media/logo.af8c03e9.svg";